<template>
    <!-- HEADER -->
    <header class="header" id="header">
        <div class="header-container">
            <div class="header-login">
                <a href="/tt">
                    <span>
                        Войти
                    </span>
                    <GPlus></GPlus>
                </a>
            </div>
            <div class="header-content">
                <span class="header-content-txt">Еще один таск трекер?</span>
                <div class="header-content-logo">
                    <HeaderLogo></HeaderLogo>
                </div>
                <span class="header-content-txt">Да, и возможности — <span>огонь!</span></span>
            </div>
        </div>
        <!-- NAVBAR -->
        <affix class="navbar navbar-default" relative-element-selector="#main" :offset="{ top: 52, bottom: 0 }"
               ref="nav">
            <div class="container-fluid">
                <!-- Brand and Toggle -->
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse"
                            @click.prevent="openMenu = !openMenu">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="">
                        <HeaderLogo></HeaderLogo>
                    </a>
                </div>
                <!-- End Brand and Toggle -->
                <!-- Menu -->
                <div class="collapse navbar-collapse" id="navbar-collapse-1" :aria-expanded="openMenu ? true : false">
                    <scrollactive class="nav navbar-nav" active-class="active" :offset="200" :duration="1000"
                                  bezier-easing-value=".5,0,.35,1">
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#header" class="scrollactive-item">Главная</a>
                        </li>
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#features" class="scrollactive-item">Преимущества</a>
                        </li>
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#overview" class="scrollactive-item">Возможности</a>
                        </li>
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#gallery" class="scrollactive-item">Галерея</a>
                        </li>
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#download" class="scrollactive-item">Подписаться</a>
                        </li>
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#donate" class="scrollactive-item">Поддержать</a>
                        </li>
                        <li data-toggle="collapse" :aria-expanded="openMenu ? true : false"
                            :class="{collapsed: openMenu == false}">
                            <a href="#contact" class="scrollactive-item">Контакты</a>
                        </li>
                    </scrollactive>
                    <div class="header-lang">
                        <a href="#">EN</a>
                        <a href="#" class="active">RU</a>
                    </div>
                </div>
                <!-- End Menu -->
            </div>
        </affix>
        <!-- END NAVBAR -->
    </header>
    <!-- END HEADER -->
</template>

<script>
    import HeaderLogo from '@/assets/svg/tt_logo5_text.svg';
    import GPlus from '@/assets/svg/g+.svg';
    import $ from 'jquery';

    export default {
        name: 'Header',
        components: {
            HeaderLogo,
            GPlus
        },
        data() {
            return {
                openMenu: false
            }
        },
        mounted(){
            $('.navbar-toggle').on('click', function () {
                $('.navbar-collapse').slideToggle();
            })
        }
    };
</script>



// WEBPACK FOOTER //
// Header.vue?69a6a346